import { contactUsApiBaseUrl } from '@/config'

export interface contactUsQueryData {
  rating?: string
  consent?: string
}
export interface contactUsQueryRequest {
  email: string
  name: string
  message: string
  token: string
  category: string
  data: contactUsQueryData
}

async function contactUsQuery(payload: contactUsQueryRequest): Promise<null> {
  try {
    const response = await fetch(`${contactUsApiBaseUrl}/api/v1/contact-us/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })

    if (response.ok) {
      return null
    } else {
      const errorData = await response.json()
      throw new Error(JSON.stringify(errorData))
    }
  } catch (error) {
    console.error(error)
    throw new Error(`Unknown error in contact us request: ${error}`)
  }
}

export { contactUsQuery }
